import { PatchNotes } from "../../types/patches";

export const patch: PatchNotes = {
  id: "patch-5.0.11009",
  buildId: "5.0.11009",
  name: "Patch 11009",
  season: 0,
  type: "patch",
  officialUrl: "https://www.ageofempires.com/news/age-of-empires-iv-patch-11009",
  summary: "",
  introduction: `
![](https://www.ageofempires.com/wp-content/uploads/2022/02/d0f6e443-4948-4f4e-896b-c9d962b3542f-1080x608.jpg)
""`,
  date: new Date("2022-01-29T00:55:31Z"),
  sections: [

  ],
};
